export enum SelectProfileEnum {
    Employee = "employee",
    Patient = "patient"
}
